import {default as axios} from "./axiosConfig";
import config, {axiosConfig} from "../config";
import moment from "moment";

export async function createLead(phone: string, siteProduct: string) {
    const {status} = await axios.post(`${config.CREATE_LEAD_API_URL}`,
        {
            apiVersion: config.leadCreateApiVersion,
            partnerToken: config.leadCreatePartnerToken,
            phoneNumber: phone,
            siteProduct: siteProduct,
            siteCreationDate: moment.utc(moment.now()).local().toISOString(true)
        }, axiosConfig);

    return status === 200;
}
